import React, { useState, useEffect, useRef } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import todoService from '../../services/todoService';
import todoColumnService from '../../services/todoColumnService';
import './Todos.css';

const Todos = () => {
  const [columns, setColumns] = useState([]);
  const [todosByStatus, setTodosByStatus] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showColumnModal, setShowColumnModal] = useState(false);
  const [editingTodo, setEditingTodo] = useState(null);
  const [editingColumn, setEditingColumn] = useState(null);
  const [openMenuId, setOpenMenuId] = useState(null);
  const menuRef = useRef(null);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    priority: 'medium',
    due_date: '',
    tags: [],
    type: 'To Do'
  });
  const [columnFormData, setColumnFormData] = useState({
    name: '',
    color: '#3b82f6'
  });
  const [tagInput, setTagInput] = useState('');
  const [showArchived, setShowArchived] = useState(false);

  useEffect(() => {
    fetchColumns();
    fetchTodos();
  }, [showArchived]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenuId(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleMenu = (todoId) => {
    setOpenMenuId(openMenuId === todoId ? null : todoId);
  };

  const fetchColumns = async () => {
    try {
      const data = await todoColumnService.getColumns();
      setColumns(data);

      // Initialize todosByStatus with column names
      const initialTodos = {};
      data.forEach(column => {
        const statusKey = column.name.toLowerCase().replace(/\s+/g, '-');
        initialTodos[statusKey] = [];
      });
      setTodosByStatus(initialTodos);
    } catch (err) {
      console.error('Error fetching columns:', err);
      setError('Failed to fetch columns');
    }
  };

  const fetchTodos = async () => {
    try {
      setLoading(true);
      const data = await todoService.getTodosByStatus({ is_archived: showArchived });

      console.log("dtttttt", data)
      // Ensure tags are always arrays
      const normalizedData = {};
      console.log("dtttttt", normalizedData)

      Object.keys(data.todosByStatus || {}).forEach(status => {
        normalizedData[status] = (data.todosByStatus[status] || []).map(todo => ({
          ...todo,
          tags: Array.isArray(todo.tags) ? todo.tags : (todo.tags ? JSON.parse(todo.tags) : [])
        }));
      });

            console.log("dtttttt", normalizedData)


      setTodosByStatus(prev => ({
        ...prev,
        ...normalizedData
      }));
      setError(null);
    } catch (err) {
      setError('Failed to fetch todos');
      console.error('Error fetching todos:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAddTag = (e) => {
    if (e.key === 'Enter' && tagInput.trim()) {
      e.preventDefault();
      if (!formData.tags.includes(tagInput.trim())) {
        setFormData(prev => ({
          ...prev,
          tags: [...prev.tags, tagInput.trim()]
        }));
      }
      setTagInput('');
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    setFormData(prev => ({
      ...prev,
      tags: prev.tags.filter(tag => tag !== tagToRemove)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingTodo) {
        await todoService.updateTodo(editingTodo.id, formData);
      } else {
        await todoService.createTodo({
          ...formData,
          status: 'pending'
        });
      }
      setShowModal(false);
      setEditingTodo(null);
      setFormData({
        title: '',
        description: '',
        priority: 'medium',
        due_date: '',
        tags: []
      });
      fetchTodos();
    } catch (err) {
      setError('Failed to save todo');
      console.error('Error saving todo:', err);
    }
  };

  const handleEdit = (todo) => {
    setEditingTodo(todo);
    setFormData({
      title: todo.title,
      description: todo.description || '',
      priority: todo.priority,
      due_date: todo.due_date || '',
      tags: todo.tags || [],
      type: todo.type || 'To Do'
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this todo?')) {
      try {
        await todoService.deleteTodo(id);
        fetchTodos();
      } catch (err) {
        setError('Failed to delete todo');
        console.error('Error deleting todo:', err);
      }
    }
  };

  const handleArchive = async (id) => {
    try {
      await todoService.archiveTodo(id);
      fetchTodos();
    } catch (err) {
      setError('Failed to archive todo');
      console.error('Error archiving todo:', err);
    }
  };

  const handleUnarchive = async (id) => {
    try {
      await todoService.unarchiveTodo(id);
      fetchTodos();
    } catch (err) {
      setError('Failed to unarchive todo');
      console.error('Error unarchiving todo:', err);
    }
  };

  const onDragEnd = async (result) => {
    const { source, destination, draggableId, type } = result;

    // Dropped outside the list
    if (!destination) {
      return;
    }

    // No movement
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }

    // Handle column reordering
    if (type === 'COLUMN') {
      const newColumns = Array.from(columns);
      const [movedColumn] = newColumns.splice(source.index, 1);
      newColumns.splice(destination.index, 0, movedColumn);

      // Update state optimistically
      setColumns(newColumns);

      // Update backend
      try {
        const columnsWithOrder = newColumns.map((col, index) => ({
          id: col.id,
          order_index: index
        }));
        await todoColumnService.reorderColumns(columnsWithOrder);
      } catch (err) {
        setError('Failed to reorder columns');
        console.error('Error reordering columns:', err);
        fetchColumns();
      }
      return;
    }

    // Handle todo card reordering (existing logic)
    const sourceStatus = source.droppableId;
    const destStatus = destination.droppableId;

    // Create a copy of the current state
    const newTodosByStatus = { ...todosByStatus };
    const sourceTodos = Array.from(newTodosByStatus[sourceStatus]);
    const destTodos = sourceStatus === destStatus
      ? sourceTodos
      : Array.from(newTodosByStatus[destStatus]);

    // Remove from source
    const [movedTodo] = sourceTodos.splice(source.index, 1);

    // Add to destination
    if (sourceStatus === destStatus) {
      sourceTodos.splice(destination.index, 0, movedTodo);
      newTodosByStatus[sourceStatus] = sourceTodos;
    } else {
      destTodos.splice(destination.index, 0, movedTodo);
      newTodosByStatus[sourceStatus] = sourceTodos;
      newTodosByStatus[destStatus] = destTodos;
    }

    // Update state optimistically
    setTodosByStatus(newTodosByStatus);

    // Update backend
    try {
      await todoService.updateTodoOrder(
        draggableId,
        destination.index,
        destStatus
      );
    } catch (err) {
      // Revert on error
      setError('Failed to update todo order');
      console.error('Error updating todo order:', err);
      fetchTodos();
    }
  };

  // Column management functions
  const handleAddColumn = () => {
    setEditingColumn(null);
    setColumnFormData({ name: '', color: '#3b82f6' });
    setShowColumnModal(true);
  };

  const handleEditColumn = (column) => {
    setEditingColumn(column);
    setColumnFormData({ name: column.name, color: column.color });
    setShowColumnModal(true);
  };

  const handleColumnSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingColumn) {
        await todoColumnService.updateColumn(editingColumn.id, columnFormData);
      } else {
        await todoColumnService.createColumn(columnFormData);
      }
      setShowColumnModal(false);
      fetchColumns();
      fetchTodos();
    } catch (err) {
      setError('Failed to save column');
      console.error('Error saving column:', err);
    }
  };

  const handleDeleteColumn = async (columnId) => {
    if (!window.confirm('Are you sure you want to delete this column? This action cannot be undone.')) {
      return;
    }
    try {
      await todoColumnService.deleteColumn(columnId);
      fetchColumns();
      fetchTodos();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to delete column');
      console.error('Error deleting column:', err);
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return '#ef4444';
      case 'medium':
        return '#f59e0b';
      case 'low':
        return '#10b981';
      default:
        return '#6b7280';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'pending':
        return 'To Do';
      case 'in-progress':
        return 'In Progress';
      case 'completed':
        return 'Completed';
      default:
        return status;
    }
  };

  if (loading) {
    return <div className="todos-loading">Loading todos...</div>;
  }

  return (
    <div className="todos-container">
      <div className="todos-header">
        <h1>My Todos</h1>
        <div className="todos-header-actions">
          <button
            className="btn-add-column"
            onClick={handleAddColumn}
          >
            + Add Column
          </button>
          <button
            className="btn-toggle-archived"
            onClick={() => setShowArchived(!showArchived)}
          >
            {showArchived ? 'Show Active' : 'Show Archived'}
          </button>
          <button
            className="btn-add-todo"
            onClick={() => {
              setEditingTodo(null);
              setFormData({
                title: '',
                description: '',
                priority: 'medium',
                due_date: '',
                tags: [],
                type: 'To Do'
              });
              setShowModal(true);
            }}
          >
            + Add Todo
          </button>
        </div>
      </div>

      {error && (
        <div className="todos-error">
          {error}
          <button onClick={() => setError(null)}>×</button>
        </div>
      )}

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="all-columns" direction="horizontal" type="COLUMN">
          {(provided) => (
            <div
              className="todos-board"
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {columns.map((column, columnIndex) => {
                const statusKey = column.name.toLowerCase().replace(/\s+/g, '-');
                const todos = todosByStatus[statusKey] || [];

                return (
                  <Draggable
                    key={column.id}
                    draggableId={`column-${column.id}`}
                    index={columnIndex}
                    type="COLUMN"
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        className={`todos-column ${snapshot.isDragging ? 'column-dragging' : ''}`}
                      >
                        <div
                          className="todos-column-header"
                          style={{ borderTopColor: column.color }}
                          {...provided.dragHandleProps}
                        >
                          <div className="column-header-left">
                            <h2>{column.name}</h2>
                            <span className="todos-count">{todos.length}</span>
                          </div>
                          {!column.is_default && (
                            <div className="column-header-actions">
                              <button
                                className="btn-icon"
                                onClick={() => handleEditColumn(column)}
                                title="Edit column"
                              >
                                ✏️
                              </button>
                              <button
                                className="btn-icon btn-danger"
                                onClick={() => handleDeleteColumn(column.id)}
                                title="Delete column"
                              >
                                🗑️
                              </button>
                            </div>
                          )}
                        </div>

                        <Droppable droppableId={statusKey} type="TODO">
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                              className={`todos-list ${snapshot.isDraggingOver ? 'dragging-over' : ''}`}
                            >
                              {todos.map((todo, index) => (
                                <Draggable
                                  key={todo.id}
                                  draggableId={todo.id}
                                  index={index}
                                  type="TODO"
                                >
                                  {(provided, snapshot) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      className={`todo-card ${snapshot.isDragging ? 'dragging' : ''}`}
                                    >
                                      <div className="todo-card-header">
                                        <div
                                          className="todo-priority"
                                          style={{ backgroundColor: getPriorityColor(todo.priority) }}
                                          title={`${todo.priority} priority`}
                                        />
                                        <h3>{todo.title}</h3>

                                        <div className="todo-menu-container" ref={openMenuId === todo.id ? menuRef : null}>
                                          <button
                                            className="btn-menu"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              toggleMenu(todo.id);
                                            }}
                                            title="More options"
                                          >
                                            ⋮
                                          </button>

                                          {openMenuId === todo.id && (
                                            <div className="todo-dropdown-menu">
                                              <button
                                                className="menu-item"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleEdit(todo);
                                                  setOpenMenuId(null);
                                                }}
                                              >
                                                <span className="menu-icon">✏️</span>
                                                <span>Edit</span>
                                              </button>

                                              {showArchived ? (
                                                <button
                                                  className="menu-item"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleUnarchive(todo.id);
                                                    setOpenMenuId(null);
                                                  }}
                                                >
                                                  <span className="menu-icon">📤</span>
                                                  <span>Unarchive</span>
                                                </button>
                                              ) : (
                                                <button
                                                  className="menu-item"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleArchive(todo.id);
                                                    setOpenMenuId(null);
                                                  }}
                                                >
                                                  <span className="menu-icon">📥</span>
                                                  <span>Archive</span>
                                                </button>
                                              )}

                                              <button
                                                className="menu-item menu-item-danger"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleDelete(todo.id);
                                                  setOpenMenuId(null);
                                                }}
                                              >
                                                <span className="menu-icon">🗑️</span>
                                                <span>Delete</span>
                                              </button>
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      {todo.type && (
                                        <div className="todo-type-badge">
                                          <span className={`type-badge type-${todo.type.toLowerCase().replace(/\s+/g, '-')}`}>
                                            {todo.type}
                                          </span>
                                        </div>
                                      )}

                                      {todo.description && (
                                        <p className="todo-description">{todo.description}</p>
                                      )}

                                      {todo.due_date && (
                                        <div className="todo-due-date">
                                          📅 {new Date(todo.due_date).toLocaleDateString()}
                                        </div>
                                      )}

                                      {todo.tags && Array.isArray(todo.tags) && todo.tags.length > 0 && (
                                        <div className="todo-tags">
                                          {todo.tags.map((tag, idx) => (
                                            <span key={idx} className="todo-tag">{tag}</span>
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingTodo ? 'Edit Todo' : 'Add New Todo'}</h2>
              <button className="modal-close" onClick={() => setShowModal(false)}>
                ×
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="title">Title *</label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter todo title"
                />
              </div>

              <div className="form-group">
                <label htmlFor="description">Description</label>
                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  rows="3"
                  placeholder="Enter todo description"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="type">Type</label>
                  <select
                    id="type"
                    name="type"
                    value={formData.type}
                    onChange={handleInputChange}
                  >
                    <option value="To Do">To Do</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Completed">Completed</option>
                    <option value="Bug">Bug</option>
                    <option value="Feature">Feature</option>
                    <option value="Task">Task</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="priority">Priority</label>
                  <select
                    id="priority"
                    name="priority"
                    value={formData.priority}
                    onChange={handleInputChange}
                  >
                    <option value="low">Low</option>
                    <option value="medium">Medium</option>
                    <option value="high">High</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="due_date">Due Date</label>
                <input
                  type="date"
                  id="due_date"
                  name="due_date"
                  value={formData.due_date}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="tags">Tags</label>
                <input
                  type="text"
                  id="tags"
                  value={tagInput}
                  onChange={(e) => setTagInput(e.target.value)}
                  onKeyDown={handleAddTag}
                  placeholder="Type and press Enter to add tags"
                />
                <div className="tags-list">
                  {formData.tags.map((tag, idx) => (
                    <span key={idx} className="tag-item">
                      {tag}
                      <button
                        type="button"
                        onClick={() => handleRemoveTag(tag)}
                        className="tag-remove"
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              </div>

              <div className="modal-actions">
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn-submit">
                  {editingTodo ? 'Update' : 'Create'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showColumnModal && (
        <div className="modal-overlay" onClick={() => setShowColumnModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingColumn ? 'Edit Column' : 'Add New Column'}</h2>
              <button className="modal-close" onClick={() => setShowColumnModal(false)}>
                ×
              </button>
            </div>

            <form onSubmit={handleColumnSubmit}>
              <div className="form-group">
                <label htmlFor="column-name">Column Name *</label>
                <input
                  type="text"
                  id="column-name"
                  name="name"
                  value={columnFormData.name}
                  onChange={(e) => setColumnFormData(prev => ({ ...prev, name: e.target.value }))}
                  required
                  placeholder="Enter column name (e.g., Moved to Production)"
                />
              </div>

              <div className="form-group">
                <label htmlFor="column-color">Column Color</label>
                <input
                  type="color"
                  id="column-color"
                  name="color"
                  value={columnFormData.color}
                  onChange={(e) => setColumnFormData(prev => ({ ...prev, color: e.target.value }))}
                />
              </div>

              <div className="modal-actions">
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={() => setShowColumnModal(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn-submit">
                  {editingColumn ? 'Update' : 'Create'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Todos;

// --- - Todos Component with Drag & Drop and Dynamic Columns